import { requestJson } from '../../../shared/api/http'
import { decodePostsResponse } from '../../posts/api/postsCodec'
import type { PostDto } from '../../posts/model/contracts'

export async function addBookmark(postId: string): Promise<void> {
  await requestJson<void>(`/api/v1/posts/${postId}/bookmark`, { method: 'POST' })
}

export async function removeBookmark(postId: string): Promise<void> {
  await requestJson<void>(`/api/v1/posts/${postId}/bookmark`, { method: 'DELETE' })
}

type BookmarksResult = {
  items: PostDto[]
  total: number
}

export async function fetchBookmarks(query: {
  limit?: number
  offset?: number
}): Promise<BookmarksResult> {
  const params = new URLSearchParams()
  if (query.limit !== undefined) params.set('limit', String(query.limit))
  if (query.offset !== undefined) params.set('offset', String(query.offset))
  const suffix = params.toString()
  const json = await requestJson<unknown>(
    `/api/v1/me/bookmarks${suffix ? `?${suffix}` : ''}`,
    { method: 'GET' },
  )
  const decoded = decodePostsResponse(json)
  return { items: decoded.items, total: decoded.total ?? decoded.items.length }
}
